import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { Conversation } from 'utils/types';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

function groupConversations(conversations: Conversation[]) {
  const groups: Record<string, Conversation[]> = {};
  const now = dayjs();
  const today = now.format('YYYY-MM-DD');
  const yesterday = now.subtract(1, 'day').format('YYYY-MM-DD');
  const pastWeekStart = now.subtract(7, 'day').startOf('day');
  const lastMonthStart = now.subtract(1, 'month').startOf('month');
  const lastMonthEnd = lastMonthStart.endOf('month');

  conversations.forEach((convo) => {
    const created = dayjs(convo.createdAt);
    const createdDate = created.format('YYYY-MM-DD');
    let label = '';

    if (createdDate === today) {
      label = 'Today';
    } else if (createdDate === yesterday) {
      label = 'Yesterday';
    } else if (created.isSameOrAfter(pastWeekStart)) {
      label = 'Past Week';
    } else if (
      created.isSameOrAfter(lastMonthStart) &&
      created.isSameOrBefore(lastMonthEnd)
    ) {
      label = 'Last Month';
    } else {
      label = created.format('MMM YYYY');
    }

    if (!groups[label]) {
      groups[label] = [];
    }
    groups[label].push(convo);
  });

  const sortedGroups: Record<string, Conversation[]> = {};

  if (groups['Today']) {
    sortedGroups['Today'] = groups['Today'];
  }

  Object.keys(groups)
    .sort((a, b) => (a === 'Today' ? -1 : b === 'Today' ? 1 : 0))
    .forEach((key) => {
      if (key !== 'Today') {
        sortedGroups[key] = groups[key];
      }
    });

  return sortedGroups;
}

export default groupConversations;
